package com.exura.chartsJS

@JsModule("chartjs-plugin-zoom") @JsNonModule external val ZoomPlugin: dynamic
@JsModule("chartjs-plugin-annotation") @JsNonModule external val AnnotationPlugin: dynamic
@JsModule("chartjs-plugin-datalabels") @JsNonModule external val DataLabelsPlugin: dynamic

fun initCharts() {
    Chart.register(ZoomPlugin, AnnotationPlugin, DataLabelsPlugin)
}
